import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Container } from 'reactstrap';
import authProtection from '../../HOCs/authProtection';
import Header from '../../components/Header/';
import Sidebar from '../../components/Sidebar/';
import Breadcrumb from '../../components/Breadcrumb/';
import Aside from '../../components/Aside/';
import Footer from '../../components/Footer/';
import GoNationForms from '../../components/GoNationForms/GoNationForms';

// import Dashboard from '../../views/Dashboard/'
// import Charts from '../../views/Charts/'
// import Widgets from '../../views/Widgets/'

// Components
// import Buttons from '../../views/Components/Buttons/'
// import Cards from '../../views/Components/Cards/'
// import Forms from '../../views/Components/Forms/'
// import Modals from '../../views/Components/Modals/'
// import SocialButtons from '../../views/Components/SocialButtons/'
// import Switches from '../../views/Components/Switches/'
// import Tables from '../../views/Components/Tables/'
// import Tabs from '../../views/Components/Tabs/'
import AddBusiness from '../../views/Pages/AddBusiness';
import ClaimBusiness from '../../views/Pages/NewClaimBusiness';
import DeleteRequests from '../../views/Pages/DeleteRequests';
import Geofences from '../../views/Pages/Geofences';
import Categories from '../../views/Pages/Categories/Categories';
import CategoryGroups from '../../views/Pages/Categories/CategoryGroups';
import Users from '../../views/Pages/Users/Users';
import SearchBusinesses from '../../views/Pages/SearchBusinesses';
import PoweredPending from '../../views/Pages/PoweredPending';
import AdminRoutes from '../../views/Pages/AdminRoutes';
import CreateUser from '../../views/Pages/CreateUser';
import PoweredImages from '../../views/Pages/PoweredImages';
import GoNationTV from '../../views/Pages/GoNationTV';

import CopyInventory from '../../views/Pages/CopyInventory';
import Flags from '../../views/Pages/Flags';

import CreatePartner from '../../views/Pages/Partnership/CreatePartner';
import ViewPartners from '../../views/Pages/Partnership/ViewPartners';
import ViewSinglePartner from '../../views/Pages/Partnership/ViewSinglePartner';
import CreateCategoryGroup from '../../views/Pages/Partnership/CreateCategoryGroup';
import EditCategoryGroup from '../../views/Pages/Partnership/EditCategoryGroup';

// Icons
import FontAwesome from '../../views/Icons/FontAwesome/';
import SimpleLineIcons from '../../views/Icons/SimpleLineIcons/';
import ViewBusinessImages from '../../views/Pages/ViewBusinessImages';

class Full extends Component {
  render() {
    return (
      <div className="app">
        <Header />
        <div className="app-body">
          <Sidebar {...this.props} />
          <main className="main">
            <Breadcrumb />
            <Container fluid>
              <Switch>
                {/* <Route
                  path="/dashboard"
                  name="Dashboard"
                  component={Dashboard}
                /> */}
                <Route path="/add-business" name="Add Business" component={AddBusiness} />
                <Route path="/forms" name="Forms" component={GoNationForms} />
                <Route
                  path="/search-businesses"
                  name="Search Businesses"
                  component={SearchBusinesses}
                />
                <Route path="/powered-pending" name="Powered Pending" component={PoweredPending} />
                <Route path="/powered-images" name="Powered Images" component={PoweredImages} />
                <Route
                  exact
                  path="/business/:id/view-images"
                  name="View Business Images"
                  component={ViewBusinessImages}
                />
                <Route path="/copy-inventory" name="Copy Inventory" component={CopyInventory} />
                <Route path="/business-claims" name="Business Claims" component={ClaimBusiness} />
                <Route path="/admin-routes" name="Admin Routes" component={AdminRoutes} />
                <Route path="/create-user" name="Create User" component={CreateUser} />
                <Route path="/delete-requests" name="Delete Requests" component={DeleteRequests} />
                <Route path="/geofences" name="Geofences" component={Geofences} />
                <Route path="/categories" name="Categories" component={Categories} />
                <Route
                  exact
                  path="/category-groups"
                  name="Category Groups"
                  component={CategoryGroups}
                />
                <Route
                  exact
                  path="/category-groups/create"
                  name="Create Category Group"
                  component={CreateCategoryGroup}
                />
                <Route path="/users" name="Users" component={Users} />
                <Route path="/flags" name="FlaggedItems" component={Flags} />
                <Route path="/partnership/create" name="CreatePartner" component={CreatePartner} />
                <Route
                  path="/partnership/view-partners"
                  name="ViewPartners"
                  component={ViewPartners}
                />
                <Route
                  exact
                  path="/partners/:id"
                  name="ViewSinglePartner"
                  component={ViewSinglePartner}
                />
                <Route
                  path="/partners/:id/category-groups/create"
                  name="CreateCategoryGroup"
                  component={CreateCategoryGroup}
                />
                <Route
                  path={[
                    '/partners/:id/category-groups/edit/:categoryId',
                    '/category-groups/edit/:categoryId',
                  ]}
                  name="EditCategoryGroup"
                  component={EditCategoryGroup}
                />
                <Route path="/gonation-tv" name="GoNation TV" component={GoNationTV} />
                <Redirect from="/" to="/add-business" />
              </Switch>
            </Container>
          </main>
          <Aside />
        </div>
      </div>
    );
  }
}

export default authProtection(Full);



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js